// Shared layout constants
export const EMBEDDED_CHAT_WIDTH = "max(384px, 28vw)"
